import { render, staticRenderFns } from "./ExamLayout.vue?vue&type=template&id=a2915758&"
import script from "./ExamLayout.vue?vue&type=script&lang=js&"
export * from "./ExamLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/components/ExamLayout.vue"
export default component.exports